<script>
    export let fill = '#FFF'
</script>

<style>
    svg {
        position: absolute;
        top: 254px;
        left: 22px;
        width: 68px;
    }
</style>

<svg id="today-label" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 202.46 58.56">
    <g>
        <rect {fill} id="topbar" y="0" width="202.46" height="58.56"/>
    </g>
</svg>